




import { Component } from 'vue-property-decorator'

// mixins
import VKIDMixin from '@/mixins/VKIDMixin'

@Component
export default class VKFreeCourse extends VKIDMixin {
  private mounted() {
    this.vkFreeCourse()
  }
}
